import { DefaultDropdownOption } from '@app/framework/constants/general.constants';
import { ManagedFile } from '@app/framework/interfaces/file.type';

export type PrimeInvoiceStatus = 'paid' | 'not_paid' | 'review';

export interface PrimeInvoice {
  id: number;
  files: ManagedFile[];
  project_id: number;
  status: PrimeInvoiceStatus;
  invoice_number: string;
  invoice_date: string;
  paid_date: string;
  user_id: number;
  description: string;
  retainage_version_id: number;
  invoice_items: InvoiceItem[];
  is_editable: boolean;
}

export interface PrimeInvoiceSaveRequestData {
  id?: number;
  project_id: number;
  status: PrimeInvoiceStatus;
  invoice_number: string;
  invoice_date: string;
  paid_date: string | null;
  description: string;
  invoice_items: {
    sov_id: string;
    current_amount: number;
    current_retainage: number;
    retainage_release: number;
  }[];
}

export interface InvoiceItem extends PrimeInvoiceSOVData {
  id: number;
  prime_invoice_id: number;
}

export const PrimeInvoiceStatusOptions = [
  { value: 'paid', label: 'Paid' },
  { value: 'not_paid', label: 'Not Paid' },
  { value: 'review', label: 'Review' },
];

export type PrimeInvoiceSOVData = {
  id?: number;
  sov_id: string;
  name: string;
  value: number;
  previous_invoice_amount: number;
  retainage_rate: number;
  remaining_retainage: number;

  // added on frontend
  current_amount: number;
  current_retainage: number;
  retainage_release: number;
  retainage_release_percent: number;
  invoice_value: number;
  completed: number;
  to_complete: number;
  retainage_balance: number;
};

export const retainageRates: DefaultDropdownOption[] = [
  { label: '0%', value: 0 },
  { label: '10%', value: 10 },
  { label: '20%', value: 20 },
  { label: '30%', value: 30 },
  { label: '40%', value: 40 },
  { label: '50%', value: 50 },
  { label: '60%', value: 60 },
  { label: '70%', value: 70 },
  { label: '80%', value: 80 },
  { label: '90%', value: 90 },
  { label: '100%', value: 100 },
];
